<template>
    <div class="couponListWrap fc ac">
        <div class="listNav fr ac jsb">
            <div
                @click="switchType('coupon')"
                :class="
                    activeType == 'coupon' ? 'navItem navActive' : 'navItem'
                "
            >
                我的券
            </div>
            <div
                @click="switchType('card')"
                :class="activeType == 'card' ? 'navItem navActive' : 'navItem'"
            >
                我的卡
            </div>
        </div>
        <div v-show="activeType == 'coupon'" class="contentWrap fc ac">
            <!-- 暂无优惠券 -->
            <div v-show="!couponList.length" class="noData fc ac">
                <span>您还没有优惠券~</span>
                <button @click="addCoupon('coupon')">添加优惠券</button>
            </div>
            <div
                v-show="couponList.length"
                @click="addCoupon('coupon')"
                class="addCoupon center"
            >
                +添加优惠券
            </div>
            <div v-show="couponList.length" class="listWrap fc ac">
                <div
                    @click="viewDetail(item)"
                    class="itemWrap"
                    v-for="(item, index) in couponList"
                    :key="index"
                >
                    <img
                        class="couponBg"
                        src="../../../static/imgs/movie/coupon_bg.png"
                        alt=""
                    />
                    <div class="couponItem fc">
                        <div class="basicInfo fr ac jsb">
                            <h3 class="couponName">
                                {{ item.amount }}元{{
                                    item.type == "D"
                                        ? "电影兑换券"
                                        : item.type == "A"
                                        ? "电影优惠券"
                                        : ""
                                }}
                            </h3>
                            <span
                                class="couponStatus"
                                v-show="item.status == 'C'"
                                >未激活</span
                            >
                            <span
                                class="couponStatus"
                                v-show="item.status == 'L'"
                                >冻结</span
                            >
                            <span
                                class="couponStatus"
                                v-show="item.status == 'U'"
                                >已使用</span
                            >
                            <span
                                class="couponStatus"
                                v-show="item.status == 'D'"
                                >删除</span
                            >
                            <span
                                class="couponStatus"
                                v-show="item.status == 'E'"
                                >已过期</span
                            >
                            <span
                                class="couponStatus active"
                                v-show="item.status == 'Y'"
                                >已激活</span
                            >
                        </div>
                        <span class="valid"
                            >有效日期至：{{ item.enddate }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div v-show="showDetail" class="detailLayer fc jc ac">
            <div class="couponDetail fc">
                <h4>优惠券详情</h4>
                <div class="infoBox fc">
                    <div class="row fr ac jsb">
                        <span>卡号：</span>
                        <p>{{ activeDetail.cardno }}</p>
                    </div>
                    <div class="row fr ac jsb">
                        <span>有效日期：</span>
                        <p>
                            {{ activeDetail.startdate }}至{{
                                activeDetail.enddate
                            }}
                        </p>
                    </div>
                    <div class="row fr ac jsb">
                        <span>版本：</span>
                        <p>{{ activeDetail.edition }}</p>
                    </div>
                    <div class="row fr jsb">
                        <span>使用说明：</span>
                        <p class="desp">{{ activeDetail.instruction }}</p>
                    </div>
                </div>
            </div>
            <img
                @click="closeLayer"
                src="../../../static/imgs/movie/close.png"
                alt=""
                class="close"
            />
        </div>
        <dir v-show="activeType == 'card'" class="contentWrap fc ac">
            <!-- 暂无贵宾卡 -->
            <div v-show="!cardList.length" class="noData fc ac">
                <span>您还没有贵宾卡~</span>
                <button @click="addCoupon('card')">添加贵宾卡</button>
            </div>
            <div
                v-show="cardList.length"
                @click="addCoupon('card')"
                class="addCoupon center"
            >
                +添加贵宾卡
            </div>
            <div v-show="cardList.length" class="cardList fc ac">
                <div
                    class="cardItemWrap fc ac"
                    v-for="(item, index) in cardList"
                    :key="index"
                >
                    <img
                        src="../../../static/imgs/movie/card_bg.png"
                        class="cardBg"
                        alt=""
                    />
                    <div class="basicInfo fc">
                        <span class="balance"
                            >余额：{{ item.balance / 100 }}片</span
                        >
                        <span class="validity">有效期至{{ item.enddate }}</span>
                    </div>
                    <p class="line"></p>
                    <div class="detailedInfo fr ac jsb">
                        <span class="cardNo">卡号：{{ item.cardno }}</span>
                        <span class="condition">{{ item.rangedesc }}</span>
                    </div>
                </div>
            </div>
        </dir>
    </div>
</template>

<script>
export default {
    data() {
        return {
            couponList: [], //优惠券列表
            cardList: [], //贵宾卡列表
            page: 0,
            showDetail: false,
            activeDetail: {},
            activeType: "coupon",
        };
    },
    components: {},
    activated() {
        this.getCouponList();
    },
    created() {},
    methods: {
        // getCouponInfo() {
        //     this.$post({
        //         method: "member.coupon.available.list",
        //         auth_code: this.getLocal("auth_code"),
        //         tradeno: this.tradeno
        //     }).then(res => {
        //         if (res.success) {
        //             this.couponList = res.data.couponlist;
        //             // this.useCoupon();
        //         }
        //     });
        // },
        switchType(type) {
            this.activeType = type;
            this.getCouponList();
        },
        getCouponList() {
            this.$post({
                method:
                    this.activeType == "card"
                        ? "member.coupon.vipcard.list"
                        : "member.coupon.list",
                auth_code: this.getLocal("auth_code"),
                page_no: this.page,
            }).then((res) => {
                if (res.success) {
                    if (this.activeType == "card") {
                        this.cardList = res.data.couponlist;
                    } else {
                        this.couponList = res.data.couponlist;
                    }
                }
            });
        },
        addCoupon(type) {
            this.$router.push({ path: "/addCoupon", query: { type: type } });
        },
        viewDetail(item) {
            this.showDetail = true;
            // this.activeDetail = item;
            this.getCouponInfo(item.cardno);
        },
        closeLayer() {
            this.showDetail = false;
        },
        getCouponInfo(cardno) {
            this.$post({
                method: "member.coupon.get",
                auth_code: this.getLocal("auth_code"),
                cardno: cardno,
            }).then((res) => {
                if (res.success) {
                    this.activeDetail = res.data;
                }
            });
        },
    },
};
</script>
<style scoped lang="scss">
.couponListWrap {
    .listNav {
        width: 100%;
        background: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        .navItem {
            height: 100px;
            line-height: 100px;
            text-align: center;
            width: 50%;
            font-size: 28px;
            letter-spacing: 4px;
        }
        .navItem:first-of-type {
            border-right: 1px solid #eee;
        }
        .navActive {
            font-size: 32px;
            color: #e44c4a;
            position: relative;
        }
        .navActive::after {
            content: "";
            width: 60px;
            height: 6px;
            position: absolute;
            bottom: 0;
            right: calc(50% - 30px);
            background: #e44c4a;
            border-radius: 3px;
        }
    }
    .contentWrap {
        width: 100%;
        margin-top: 120px;
        padding: 0;
        .noData {
            width: 100%;
            font-size: 28px;
            padding: 150px 0;
            span {
                color: #999;
            }
            button {
                width: 216px;
                height: 72px;
                background: #e44c4a;
                color: #fff;
                border-radius: 8px;
                margin: 120px 0;
            }
        }
        .addCoupon {
            width: 100%;
            height: 100px;
            font-size: 32px;
            background: #e44c4a;
            color: #fff;
        }
        .listWrap {
            width: 100%;
            padding: 20px 20px;
            box-sizing: border-box;
            .itemWrap {
                width: 100%;
                height: 150px;
                position: relative;
                margin-bottom: 20px;
                .couponBg {
                    width: 100%;
                    height: 150px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                .couponItem {
                    width: 100%;
                    height: 150px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    padding: 0 35px;
                    box-sizing: border-box;
                    .basicInfo {
                        width: 100%;
                        height: 100px;
                        .couponName {
                            font-size: 32px;
                        }
                        .couponStatus {
                            font-size: 28px;
                            color: #999;
                        }
                        .active {
                            color: #ff5204;
                        }
                    }
                    .valid {
                        font-size: 24px;
                        color: #999;
                        height: 40px;
                        line-height: 40px;
                    }
                }
                // .couponItem:before,
                // .couponItem:after {
                //     content: "";
                //     width: 30px;
                //     height: 30px;
                //     background-color: #f2f2f2;
                //     position: absolute;
                //     top: 250px;
                //     border-radius: 50%;
                // }
                .couponItem:before {
                    left: -15px;
                    top: 120px;
                }
                .couponItem:after {
                    right: -15px;
                    top: 120px;
                }
            }
        }
        .cardList {
            .cardItemWrap {
                width: 672px;
                height: 212px;
                position: relative;
                margin-top: 30px;
                .cardBg {
                    width: 672px;
                    height: 212px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: -1;
                }
                .basicInfo {
                    width: 100%;
                    padding: 0 40px;
                    box-sizing: border-box;
                    height: 140px;
                    .balance {
                        font-size: 32px;
                        color: #cd3652;
                        margin-top: 30px;
                    }
                    .validity {
                        font-size: 22px;
                        color: #999;
                        margin-top: 20px;
                    }
                }
                .line {
                    width: 635px;
                    height: 1px;
                    border-top: 1px dashed #bbb;
                }
                .detailedInfo {
                    width: 100%;
                    padding: 0 40px;
                    box-sizing: border-box;
                    height: 68px;
                    .cardNo {
                        font-size: 22px;
                        color: #999;
                        line-height: 66px;
                    }
                    .condition {
                        font-size: 22px;
                        color: #cd3652;
                        line-height: 70px;
                    }
                }
            }
        }
    }
    .detailLayer {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba($color: #000000, $alpha: 0.4);
        .couponDetail {
            width: 690px;
            background: #fff;
            padding: 30px 0;
            border-radius: 12px;
            h4 {
                width: 100%;
                padding: 0 30px;
                font-size: 32px;
                height: 80px;
                line-height: 80px;
                box-sizing: border-box;
            }
            .infoBox {
                .row {
                    width: 100%;
                    padding: 0 30px;
                    box-sizing: border-box;
                    font-size: 28px;
                    line-height: 60px;
                    span {
                        width: 150px;
                        color: #999;
                    }
                    p {
                        width: calc(100% - 170px);
                    }
                    .desp {
                        line-height: 45px;
                        max-height: 450px;
                        overflow-y: scroll;
                        white-space: pre-line;
                    }
                }
            }
        }
        .close {
            width: 80px;
            height: 80px;
            margin-top: 70px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/coupon/couponList.vue